import React from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
const FormBuilderFormInterfaceHeading = ({ item, t }) => {
  if (!item) return null;
  const { h2, p } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  return /* @__PURE__ */ React.createElement("hgroup", { className: `${item.class}` }, /* @__PURE__ */ React.createElement("h2", null, t(h2.nodeValue)), p && /* @__PURE__ */ React.createElement("p", null, t(p.nodeValue)));
};
FormBuilderFormInterfaceHeading.displayName = "FormBuilderFormInterfaceHeading";
export default FormBuilderFormInterfaceHeading;
